import { logger } from "@otto-ec/global-resources/debug";
export const createLogger = (namespace) => {
    return logger(`benefit.${namespace}`);
};
